export default __webpack_public_path__ + "static/media/edison fluted panel.5f353633.png";